var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"app":""}},[_c('v-content',{staticClass:"white"},[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }